import { Dialog, Layout, SpinnerWheel, Text } from '@loadsmart/miranda-react'
import { getToken } from '@loadsmart/miranda-react/dist/tokens'

function BidSubmitted({ handleClose }) {
  return (
    <>
      <Dialog.Header>
        Processing Bid
        <Dialog.Close onClick={handleClose}></Dialog.Close>
      </Dialog.Header>
      <Dialog.Body>
        <Layout.Stack align="center" gap="spacing-8" paddingB="spacing-4">
          <Text color="color-text-tertiary">
            We are currently analyzing your bid, you can expect a response in a few moments
          </Text>
          <SpinnerWheel size={getToken('spacing-12')} />
        </Layout.Stack>
      </Dialog.Body>
    </>
  )
}

export { BidSubmitted }
